import {
  calculateBaseQuantity,
  calculateIngredientCost,
  getBaseUnitValue,
  getLatestUnitCost,
  isWeightOrVolumeUnit,
} from "../../../utils/helpers/pricing";
import { formatRecipeDecimal } from "./recipeNumberInput";

const materialKey = (material = {}) => String(material?.material_id || material?.id || "");

const recalculateIngredient = (ingredient, units) => ({
  ...ingredient,
  sub_total: calculateIngredientCost(ingredient, units),
});

export const buildRecipeDraft = (sourceMaterials = [], allMaterials = [], units = []) =>
  (sourceMaterials || []).map((recipe) => {
    const recipeMaterialId = recipe?.material_id || recipe?.id;
    const currentMaterial =
      (allMaterials || []).find((material) => String(material?.id) === String(recipeMaterialId)) || {};
    const unit = recipe?.unit || currentMaterial?.unit || "pcs";
    const weight = formatRecipeDecimal(recipe?.weight ?? 0);
    const qty = formatRecipeDecimal(recipe?.qty ?? 1) || "1";
    const ingredient = {
      ...currentMaterial,
      id: recipeMaterialId,
      material_id: recipeMaterialId,
      name: currentMaterial?.name || recipe?.material_name || "Material",
      material_name: currentMaterial?.name || recipe?.material_name || "Material",
      unit,
      unit_cost: getLatestUnitCost(currentMaterial) || Number(recipe?.unit_cost || 0),
      price_trend: currentMaterial?.price_trend,
      stock: Number(currentMaterial?.stock ?? recipe?.stock ?? 0),
      weight,
      qty,
    };

    return recalculateIngredient(ingredient, units);
  });

const mergeIngredientQuantity = (current, copied, units) => {
  const currentBaseUnit = getBaseUnitValue(units, current?.unit);
  const copiedBaseUnit = getBaseUnitValue(units, copied?.unit);

  if (currentBaseUnit !== copiedBaseUnit) {
    return copied;
  }

  const totalBaseQuantity = calculateBaseQuantity(current, units) + calculateBaseQuantity(copied, units);
  const usesMeasuredQuantity = isWeightOrVolumeUnit(currentBaseUnit, units);
  const merged = {
    ...current,
    ...copied,
    unit: currentBaseUnit,
    weight: usesMeasuredQuantity ? formatRecipeDecimal(totalBaseQuantity) : "0",
    qty: usesMeasuredQuantity ? "1" : formatRecipeDecimal(totalBaseQuantity),
  };

  return recalculateIngredient(merged, units);
};

export const mergeRecipeDraft = (currentMaterials = [], copiedMaterials = [], units = []) => {
  const merged = new Map((currentMaterials || []).map((material) => [materialKey(material), { ...material }]));

  (copiedMaterials || []).forEach((copied) => {
    const key = materialKey(copied);
    const current = merged.get(key);

    merged.set(key, current ? mergeIngredientQuantity(current, copied, units) : { ...copied });
  });

  return Array.from(merged.values());
};

